/**
 * ClarityMD - thanh Add to cart dinh day man hinh (mobile).
 *
 * Viec duy nhat cua file nay:
 *   1. Hien thanh khi buybox da cuon khuat khoi man hinh
 *   2. Dat `data-sel` = so thu tu goi dang chon, de CSS hien dung 1 nut
 *   3. Nut "Select" cuon nguoc len buybox khi khach chua chon goi nao
 *
 * Viec them vao gio do cmd-cart-drawer.js lo (no bat moi form /cart/add).
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('[data-cmd-sticky]');
    var buybox = document.querySelector('.cmd-buybox');
    if (!bar || !buybox) return;

    var hint = bar.querySelector('[data-cmd-sticky-hint]');
    var planField = bar.querySelector('[data-cmd-sticky-plan]');

    /* --- Dong bo goi dang chon --- */
    function sync() {
      // Chep lua chon dinh ky tu buybox sang form cua thanh sticky.
      // Thieu buoc nay thi khach chon "Subscribe & Save" o tren, bam mua o
      // duoi, se thanh mua le ma khong he hay biet.
      if (planField) {
        var plan = buybox.querySelector('.cmd-pt__plan-radio:checked');
        planField.value = plan ? plan.value : '';
      }

      var picked = buybox.querySelector('.cmd-buybox__radio:checked');
      if (!picked) {
        bar.removeAttribute('data-sel');
        if (hint) hint.textContent = 'Choose your package';
        return;
      }

      // id co dang "cmd-bundle-2" -> lay so cuoi
      var index = picked.id.split('-').pop();
      bar.setAttribute('data-sel', index);

      var tile = buybox.querySelector('.cmd-tile--' + index + ' .cmd-tile__name');
      if (hint && tile) hint.textContent = tile.textContent.trim();

      // Dang mua dinh ky -> noi ro tren thanh de khach khong bat ngo.
      var sub = buybox.querySelector('.cmd-pt__radio--sub');
      if (hint && sub && sub.checked) {
        hint.textContent = (tile ? tile.textContent.trim() : '') + ' \u00b7 Subscription';
      }
    }

    buybox.addEventListener('change', sync);
    sync();

    /* --- Chua chon goi -> cuon len buybox --- */
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cmd-sticky-scroll]')) return;

      buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Nhay nhe de khach thay ro can chon o day
      buybox.classList.add('cmd-buybox--nudge');
      setTimeout(function () {
        buybox.classList.remove('cmd-buybox--nudge');
      }, 900);
    });

    /* --- Hien thanh khi buybox khuat khoi man hinh --- */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting;
        });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(buybox);
    } else {
      // Trinh duyet cu: lo mot chut, van dung
      bar.hidden = false;
    }
  });
})();
